module.exports = __webpack_public_path__ + "static/media/1.1 Vinckboons Vorzustand_klein.b30de409.jpg";